import { FC, useEffect, useState } from "react";
import { useGetImage } from "../../../utils/image";
import { ImageObject } from "../../../hooks/database/types/inventories";

const Image: FC<{ src: ImageObject; style?: object; onClick?: () => void }> = ({ src, style, onClick }) => {
  const [source, setSource] = useState<string | undefined>();

  const getImage = useGetImage();

  useEffect(() => {
    getImage(src, true).then((thumbSrc) => {
      setSource(thumbSrc);
    });
  }, [getImage, src]);

  return <img style={style} onClick={onClick} alt="" src={source} />;
};

export default Image;
